<section>
    <div class="example-button-row">
        <button mat-raised-button color="accent" (click)="back()" >Back</button>
    </div>
</section>
<div id="h5p-player-container"></div>